import clsx from 'classnames';
import React from 'react';

import Detail from '../Detail/Detail';

export type DetailItemType = {
  icon: React.ReactNode;
  title: string;
  description: React.ReactNode;
  iconSize?: number;
};

export type DetailGroupProps = {
  items: DetailItemType[];
  className?: string;
  trailing?: React.ReactNode;
};

const DetailGroup: React.FC<DetailGroupProps> = ({
  items,
  trailing,
  className,
}) => (
  <div className={clsx('detail-group', className)}>
    {items.map(({ icon, title, description, iconSize = 48 }) => (
      <Detail
        key={`${title}`}
        icon={icon}
        iconSize={iconSize}
        title={title}
        description={description}
      />
    ))}
    {trailing ? <div className="detail-group__trailing">{trailing}</div> : null}
  </div>
);

export default DetailGroup;
